import type { ReactionType } from '@/types';

export const REACTIONS: Array<{ key: ReactionType; label: string; emoji: string; color: string }> = [
  { key: 'like', label: 'Like', emoji: '👍', color: 'text-like' },
  { key: 'love', label: 'Love', emoji: '❤️', color: 'text-love' },
  { key: 'haha', label: 'Haha', emoji: '😂', color: 'text-haha' },
  { key: 'wow', label: 'Wow', emoji: '😮', color: 'text-wow' },
  { key: 'sad', label: 'Sad', emoji: '😢', color: 'text-sad' },
];